import React, { Component } from 'react';
import { IconButton, ArrowUpIcon, ArrowDownIcon } from 'evergreen-ui';

// Constants for scroll behavior
const SCROLL_CONTENT_THRESHOLD = 10; // Minimum pixel difference to consider content scrollable
const SCROLL_TOP_THRESHOLD = 100; // Pixels scrolled from top to show "scroll to top" button

// Constants for button styling
const BUTTON_SIZE = 50; // Button width and height in pixels
const BUTTON_POSITION = 30; // Distance from bottom and right edges in pixels
const BUTTON_Z_INDEX = 1000; // High z-index to ensure button stays above content

class ScrollButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
            scrollDirection: 'down' // 'up' or 'down'
        };
        this.containerElement = null;
        this.handleScroll = this.handleScroll.bind(this);
        this.scrollToTopOrBottom = this.scrollToTopOrBottom.bind(this);
    }

    componentDidMount() {
        if (this.props.scrollContainerRef && this.props.scrollContainerRef.current) {
            this.containerElement = this.props.scrollContainerRef.current;
            this.containerElement.addEventListener('scroll', this.handleScroll);
            // Check initial scroll state
            this.handleScroll();
        }
    }

    componentWillUnmount() {
        if (this.containerElement) {
            this.containerElement.removeEventListener('scroll', this.handleScroll);
        }
    }

    handleScroll() {
        const container = this.containerElement;
        if (!container) return;

        const scrollTop = container.scrollTop;
        const scrollHeight = container.scrollHeight;
        const clientHeight = container.clientHeight;
        
        // Check if there's scrollable content
        const hasScrollableContent = scrollHeight > clientHeight + SCROLL_CONTENT_THRESHOLD;
        
        if (!hasScrollableContent) {
            if (this.state.isVisible) {
                this.setState({ isVisible: false });
            }
            return;
        }

        const scrolledFromTop = scrollTop > SCROLL_TOP_THRESHOLD;
        const newDirection = scrolledFromTop ? 'up' : 'down';

        // Only update state if it has changed
        if (!this.state.isVisible) {
            this.setState({ 
                isVisible: true, 
                scrollDirection: newDirection 
            });
        } else if (this.state.scrollDirection !== newDirection) {
            this.setState({ scrollDirection: newDirection });
        }
    }

    scrollToTopOrBottom() {
        const container = this.containerElement;
        if (!container) return;

        if (this.state.scrollDirection === 'up') {
            // Scroll to top
            container.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            // Scroll to bottom
            container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
        }
    }

    render() {
        if (!this.state.isVisible) {
            return null;
        }

        const icon = this.state.scrollDirection === 'up' ? ArrowUpIcon : ArrowDownIcon;
        const title = this.state.scrollDirection === 'up' ? 'Scroll to top' : 'Scroll to bottom';

        return (
            <IconButton
                onClick={this.scrollToTopOrBottom}
                icon={icon}
                iconColor="white"
                appearance="primary"
                intent="none"
                title={title}
                style={{
                    position: 'fixed',
                    bottom: `${BUTTON_POSITION}px`,
                    right: `${BUTTON_POSITION}px`,
                    zIndex: BUTTON_Z_INDEX,
                    borderRadius: '50%',
                    width: `${BUTTON_SIZE}px`,
                    height: `${BUTTON_SIZE}px`,
                    padding: '0',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
                }}
            />
        );
    }
}

export default ScrollButton;
